<template>
  <div>
    <BlockUI v-if="loading" :message="loadingMsg">
      <b-icon icon="three-dots" animation="cylon" font-scale="4"></b-icon>
    </BlockUI>

    <b-modal id="assessment-preview-modal" class="import_modal" centered :title="assessmentDetails.title" scrollable
      no-close-on-backdrop @close="cancel" hide-footer>
      <div class="import_modal_body">
        <assessmentPreview v-if="!loading" :questionsProp="questions" :importQuestions="importQuestions"
          :previewFlg="true" />
      </div>
    </b-modal>
  </div>
</template>

<script>
import assessmentPreview from "../CustomCreate/assessmentPreview.vue";
import { getAssessmentDetail } from "../../api";
export default {
  name: 'assessment-preview-modal',
  props: {
    data: Object,
    show: Boolean
  },
  components: {
    assessmentPreview
  },
  data() {
    return this.initialState();
  },
  computed: {

  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.$bvModal.show("assessment-preview-modal");
        this.getData();
      }
    },

  },
  methods: {
    initialState() {
      return {
        loading: false,
        loadingMsg: "Please wait...",
        questions: [],
        assessmentDetails: {}
      };
    },
    getData() {
      this.loading = true;
      console.log("aa", this.data);
      const payload = {
        Id: this.data.AssessmentId
      }
      getAssessmentDetail(payload)
        .then((resp) => {
          this.assessmentDetails = resp.data.data;
          this.questions = this.assessmentDetails.questions;
          if (this.questions && this.questions.length > 0) {
            this.questions.forEach(e => {
              e.id=e.questionId;
              const optionLetters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
              const options = e.options;
              const updatedOptions = [];
              options.forEach((element, i) => {
                if (element.isCorrect == 'Y') { e.answer = optionLetters[i]; }
                updatedOptions.push({ text: element.optionText, optionLabel: optionLetters[i] });
              });
              e.options = updatedOptions;
              const images =(e?.images || []).sort((a, b) => a.sequenceOrder - b.sequenceOrder);
              const transformedImages = images.map((element) => {
                return { element, url: element.imageUrl };
              });
              e.files = transformedImages;
            });
          }

          this.loading = false;
        })
        .catch((err) => {
          console.log("Error", err?.response?.data);
          this.loading = false;
        });
    },

    cancel() {
      this.questions = [];
      // Handle the cancellation action
      this.$emit("handleClose");

    },
  },
};
</script>
<style>
#assessment-preview-modal___BV_modal_content_ {
  width: 85vw !important;
}
</style>
